export enum BillingTimeEnum {
  LAST_15_DAYS = 'Last 15 days',
  LAST_MONTH = 'Last month',
  LAST_QUARTER = 'Last quarter',
  LAST_SEMESTER = 'Last semester',
  LAST_YEAR = 'Last year',
}
